<template>
  <VPDropdown
    :input-id="inputId"
    :options="options"
    v-bind="$attrs"
  />
</template>

<script setup lang="ts">
import VPDropdown from '@/components/form/VPDropdown.vue';
import { TrackingProviderEnum } from '@/generated/graphql';

type Props = {
  inputId: string;
};

defineProps<Props>();

type ProviderOption = {
  name: string;
  value: TrackingProviderEnum;
};

const options: ProviderOption[] = [
  { name: 'Meta', value: TrackingProviderEnum.Facebook },
  { name: 'Google Analytics', value: TrackingProviderEnum.Ga },
];
</script>
